import React from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import Security from "@/icons/__generated__/Security/Security20";

import { QuestionMarkTooltip } from "../question-mark-tooltip";

interface IdvWarningProps {
  zendeskUrlLocale?: string;
}

export const IdvWarning: React.FC<IdvWarningProps> = ({ zendeskUrlLocale }) => {
  return (
    <div className="tw-flex tw-flex-col">
      <div className="tw-flex tw-justify-between tw-items-center">
        <Security />
        <Text typeface="body-1-m-long" testId="idv-warning-text">
          <FormattedMessage defaultMessage="Identity verification may be required" />
        </Text>
        <QuestionMarkTooltip
          title={<FormattedMessage defaultMessage="Identity verification" />}
        >
          <FormattedMessage
            defaultMessage="All new customers must verify their identity before booking. {button}"
            values={{
              button: (
                <Button
                  appearance="black"
                  variant="text-only"
                  href={`https://support.peerspace.com/hc/${zendeskUrlLocale}/articles/5141300838420-What-s-needed-to-successfully-complete-identity-verification-`}
                  rel="noreferrer"
                  className="tw-body-1 tw-underline"
                >
                  <FormattedMessage defaultMessage="Learn more" />
                </Button>
              ),
            }}
          />
        </QuestionMarkTooltip>
      </div>
    </div>
  );
};
